import React, { useState } from "react";
import { Surface } from "../../../../atoms/Surface";
import { useTranslation } from "react-i18next";
import { HiChartBar, HiChevronDown, HiChevronUp } from "react-icons/hi";
import parse from "html-react-parser";

export const UtmTrackingSection: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Surface className="mt-4">
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between text-left"
      >
        <div className="flex items-center gap-2">
          <HiChartBar className="text-blue-600" size={20} />
          <div>
            <h3 className="text-sm sm:text-base font-semibold text-gray-900">
              {t("customRegistration.utmTracking.title")}
            </h3>
            <p className="text-xs text-gray-500">
              {t("customRegistration.utmTracking.subtitle")}
            </p>
          </div>
        </div>
        {isOpen ? (
          <HiChevronUp className="text-gray-500 flex-shrink-0" size={20} />
        ) : (
          <HiChevronDown className="text-gray-500 flex-shrink-0" size={20} />
        )}
      </button>

      {isOpen && (
        <div className="mt-3 pt-3 border-t border-gray-200 space-y-3">
          <p className="text-sm text-gray-700 leading-relaxed">
            {t("customRegistration.utmTracking.description")}
          </p>

          <div>
            <p className="text-xs font-medium text-gray-600 mb-1">
              {t("customRegistration.utmTracking.exampleLabel")}
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded px-3 py-2 font-mono text-xs text-gray-700 break-all">
              {parse(
                t("customRegistration.utmTracking.example", {
                  url: process.env.REACT_APP_HOST_URL,
                }) as string
              )}
            </div>
          </div>

          <ul className="text-xs text-gray-600 space-y-1 list-disc pl-5">
            <li>{t("customRegistration.utmTracking.bullet1")}</li>
            <li>{t("customRegistration.utmTracking.bullet2")}</li>
          </ul>
        </div>
      )}
    </Surface>
  );
};
